export enum ACTIONS {
    OPEN_MODAL = "OPEN_MODAL",
    CLOSE_MODAL = "CLOSE_MODAL",
    OPEN_MODAL_CONFIRM = "OPEN_MODAL_CONFIRM",
    CLOSE_MODAL_CONFIRM = "CLOSE_MODAL_CONFIRM",
    SET_EDIT_ID = "SET_EDIT_ID",
    SET_PRIORITY = "SET_PRIORITY",
    OPEN_MODAL_DELETE = "OPEN_MODAL_DELETE",
    CLOSE_MODAL_DELETE = "CLOSE_MODAL_DELETE",
    OPEN_MODAL_CHANGE_PRIORITY = "OPEN_MODAL_CHANGE_PRIORITY",
    CLOSE_MODAL_CHANGE_PRIORITY = "CLOSE_MODAL_CHANGE_PRIORITY",
    RESET_EDIT_ID = "RESET_EDIT_ID",
    RESET_PRIORITY = "RESET_PRIORITY",
    CHECKED = "CHECKED",
    CHECKED_BY_PARENT = "CHECKED_BY_PARENT",
    ADD_CHILDREN = "ADD_CHILDREN",
    DELETE_CHILDREN = "DELETE_CHILDREN",
    OPEN_MODAL_PROVIDER = "OPEN_MODAL_PROVIDER",
    CLOSE_MODAL_PROVIDER = "CLOSE_MODAL_PROVIDER",
    HANDLE_PROVIDERS_CHECK = "HANDLE_PROVIDERS_CHECK",
    HANDLE_PROVIDERS_NOT_CHECK = "HANDLE_PROVIDERS_NOT_CHECK",
    ADD_ALL_CHILDREN = "ADD_ALL_CHILDREN",
    DELETE_ALL_CHILDREN = "DELETE_ALL_CHILDREN",
    FILTER_PROVIDERS_BY_VALUE = "FILTER_PROVIDERS_BY_VALUE",
    SEARCH_VALUE = "SEARCH_VALUE",
    TOGGLE_EXPAND = "TOGGLE_EXPAND",
    SEARCH_SUBSERVICE_VALUE = "SEARCH_SUBSERVICE_VALUE",
    CHANGE_LOADER = "CHANGE_LOADER",
    INITIALIZE_ARRAYS = "INITIALIZE_ARRAYS",
    OPEN_SNACKBAR = "OPEN_SNACKBAR",
    CLOSE_SNACKBAR = "CLOSE_SNACKBAR"
}
